<div class="@container h-full" data-cy="iot-platform-ui-image-selector-v2">
  <div class="image-selector flex h-full flex-col gap-5 @xl:flex-row">
    <div class="image-selector__preview-container hidden w-52 shrink-0 @xl:block">
      @if (selectedImage()) {
        <img [src]="selectedImage()" alt="" class="image-selector__preview" #imageRef (error)="onImageError()" />
      } @else {
        <span class="image-selector__preview-placeholder">{{ 'IMAGE_SELECTOR.SELECT_IMAGE' | translate }}</span>
      }
    </div>

    <div class="image-selector__gallery flex-1">
      <div class="grid gap-2" style="grid-template-columns: repeat(auto-fill, minmax(100px, 1fr))">
        @for (image of images(); track image) {
          <div class="relative">
            <img [src]="image" (click)="onSelect(image)" (keyup)="onSelect(image)" class="image-selector__minia" alt="" />
            @if (image.toLowerCase() === selectedImage()?.toLowerCase()) {
              <mat-icon class="image-selector__check-icon">check_circle</mat-icon>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
